import { trackEvent, setAnalyticsUserId, clearAnalyticsUserId } from '@/utils/analytics'

// ── Event Name Registry ───────────────────────────────────────────────────────

export const EVENTS = Object.freeze({
  // ── Acquire ──────────────────────────────────────────────
  PAGE_VIEWED:                  'page_viewed',
  PRODUCT_VIEWED:               'product_viewed',
  SEARCH:                       'search',
  SEARCH_RESULT_CLICKED:        'search_result_clicked',
  AUTH_REDIRECT_INITIATED:      'auth_redirect_initiated',

  // ── Onboard ──────────────────────────────────────────────
  SIGNUP_STARTED:               'signup_started',
  LOGIN_STARTED:                'login_started',
  LOGIN_COMPLETED:              'login_completed',
  ONBOARDING_RESUMED:           'onboarding_resumed',
  ONBOARDING_STEP_VIEWED:       'onboarding_step_viewed',
  ONBOARDING_STEP_COMPLETED:    'onboarding_step_completed',
  ONBOARDING_STEP_FAILED:       'onboarding_step_failed',

  // ── Invest ───────────────────────────────────────────────
  FD_REDIRECTION_INITIATED:     'fd_redirection_initiated',
  INVESTMENT_STARTED:           'investment_started',
  PAYMENT_STARTED:              'payment_started',
  INVESTMENT_COMPLETED:         'investment_completed',
})

export const track = (eventName: string, payload: Record<string, unknown> = {}) => trackEvent(eventName, payload)

export { setAnalyticsUserId, clearAnalyticsUserId }

const analytics = { track, EVENTS }
export default analytics
